<script>
import { layoutMethods } from "@/state/helpers";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { reportsMethods, reportsComputed, exportMethods,erpFixMessages, erpUserRolesMethods } from "@/state/helpers"
import Swal from 'sweetalert2';
import moment from 'moment';
import { getModuleAccess } from '@/router/helper.js'

/**
 * BLVCK list component
 */
export default {
  page: {
    title: "BLVCK TransactionLogs"
  },
  data() {
    return {
      dataList: [],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      sortBy: "value",
      sortDesc: false,
      pageOptions: [10, 20, 30, 40, 50, 60, 70, 80, 90, 100],
      searchValue: {
        searchField: null,
        search: "",
        status: null,
        dateRange: null,
        payment_method: null,
      },
      sortingValue:{
        sort : "id",
        orderDesc : "",
      },
      searchList: [
        { text: "Search All", value: null },
        { text: "Transaction ID", value: "transaction_id" },
        { text: "Merchant Name", value: "name" },
        { text: "Business Name", value: "business_name" },
        { text: "Payment Method", value: "payment_method" },
      ],
      statusList: [
        { text: "All", value: null },
        { text: "Pending", value: "pending" },
        { text: "Failed", value: "failed" },
        { text: "Success", value: "success" },
      ],
      isRange: null,
      rangeOptions: {
        mode: "range",
      },
      fields: [
        {
          key: "transaction_id",
          sortable: true,
        },
        {
          key: "customer_name",
          sortable: true,
        },
        {
          key: "status",
          sortable: true,
        },
        {
          key: "blvck_receive",
          sortable: true,
        },
        {
          key: "package",
          sortable: false,
        },
        {
          key: "payment_method",
          sortable: true,
          thClass: "text-end",
        },
        {
          key: "amount",
          sortable: true,
        },
        {
          key: "date",
          sortable: true,
        },
      ],
      modalView:{
        "id": 0,
        "userId": 0,
        "transactionId": "",
        "status": "",
        "amount": 0,
        "vc_amount": 0,
        "package": "",
        "package_count": 0,
        "package_type": "",
        "package_name": [],
        "paymentMethod": "",
        "subscription": 0,
        "source_intent_id": "",
        "description": "",
        "date": "",
        "updated_at": "",
        "customerInfo": {
          "userId": 0,
          "businessId": 0,
          "name": "",
          "businessName": "",
          "mobile": "",
          "email": "",
          "address": null
        },
        "transView": {
          "data": {},
          "id": "",
          "type": ""
        }
      },
      isModalOpen: false,
      blvckLogsTopups: {
        access: {
          read: false
        }
      }
    };
  },
  components: {
    flatPickr
  },
  computed: {
    ...reportsComputed,
    ...erpFixMessages,
    rows() {
      return this.dataList.length;
    },
  },
  async mounted() {
    this.changeTitle({title: 'BLVCK Top-ups'});
    this.changeBreadCrumb({
      breadCrumbs: [
        { text: 'Peddlr', to: { name: 'Home'} },
        { text: 'Report', to: { name: 'Report'}},
        { text: 'Blvck Topup Transaction', to: { name: 'BLVCK topup Transaction'}},
      ]
    });
    this.getLogs();

    // get the module access for checking if user has create, read, update, and/or delete access
    await getModuleAccess('Reports', 'BLVCK Transaction Logs', 'Top-ups')
        .then((access) => this.blvckLogsTopups.access = access);

  },
  methods: {
    ...layoutMethods,
    ...reportsMethods,
    ...exportMethods,
    ...erpUserRolesMethods,
    async onExport(){
      await this.onPageUpdate();
      if(this.blvckTopupLogsTotalRows ==0){
        Swal.fire("Failed!", this.exportNullPrompt, "warning");
        return;
      }
      let params = Object.assign(
        // this.searchValue,
        // this.sortingValue,
        {
          module: 'black_coins_topup',
          email: JSON.parse(localStorage.getItem('userData')).email,
          "dateRange": this.searchValue["dateRange"],
          "orderDesc": this.sortingValue["orderDesc"],
          "payment_method": this.searchValue["payment_method"],
          "search": this.searchValue["search"],
          "searchField": this.searchValue["searchField"],
          "sort": this.sortingValue["sort"],
          "status": this.searchValue["status"],
        });

      // delete params.page;
      // delete params.rows;
      
      this.exportReport(params)
        .then(() => Swal.fire("Success!", `Your request for reports is pending. It will be sent to your email once it's ready.`, "success"))
        .catch(() => Swal.fire("Failed!", `Your request for reports has failed.`, "warning"));
    },
    async getLogs() {
      var date_to = moment().format('YYYY-MM-DD');
      //var date_from = moment().subtract(1, 'months').format('YYYY-MM-DD');
      var date_range = date_to + ' to ' + date_to;
      this.searchValue.dateRange = date_range
      await this.getBlvckTopupLogs({
        page: this.currentPage,
        rows: this.perPage,
        ...this.sortingValue,
        dateRange: date_range
      });
    },
    async searchLog() {
      await this.getBlvckTopupLogs({
        page: this.currentPage,
        rows: this.perPage,
        ...this.searchValue,
        ...this.sortingValue
      })
    },
    getStatusClassColor(data) {
      return data === 'FAILED' ? 'text-danger fw-medium m-0' : data === 'SUCCESS' ? 'text-success fw-medium m-0' : 'text-warning fw-medium m-0'; 
    },
    async onSearch() {
      this.currentPage = 1
      if (this.searchValue.search) {
        this.searching = true
        await this.searchLog()
      } else {
        this.searching = false
        this.searchValue = {
          search: null,
          searchField: null,
        }
        await this.getLogs()
      }
    },
    async onPageUpdate(reset = "") {
      if(this.searching || this.searchValue.status != null || this.searchValue.dateRange != null || this.searchValue.sort != null || this.searchValue.payment_method != null) {
        if(reset == "reset"){
          this.currentPage = 1
        }
        await this.searchLog()
      } else {
        await this.getLogs()
      }
    },
    refresh(){
      this.sortingValue.sort = "";
      this.sortingValue.orderDesc = "";
      this.getLogs()

    },
    onDisplayChange(){
      console.log(this.blvckTopupLogsTotalRows,this.perPage,this.blvckTopupLogs.length,(this.blvckTopupLogs.length < this.blvckTopupLogsTotalRows && this.blvckTopupLogs.length != this.perPage));
      if(
        (this.blvckTopupLogs.length < this.blvckTopupLogsTotalRows && this.blvckTopupLogs.length != this.perPage) || // condition for incrementing display per page
        (this.blvckTopupLogs.length == this.blvckTopupLogsTotalRows && this.perPage < this.blvckTopupLogs.length) // condition for decreasing display per page
        ){
        this.onPageUpdate('reset')
      }
    },
    async viewModalTransaction(data) {
      if (!this.blvckLogsTopups.access.read) {
        Swal.fire(
          "Access Restricted",
          "Looks like your access is limited. Please contact your administrator.",
          "warning"
        );
      } else {
        var item = data,
            self = this,
            id   = 0;
        // this.view = data
        // console.log(JSON.stringify(this.view))
        if(Object.prototype.hasOwnProperty.call(data, "transactionId")){
          id = data.transactionId;
        }
        await this.fetchPaymongoTransaction({transactionId: id})
        .then((response) => {
            item.transView =  {
                  data: response.attributes,
                  id: response.id,
                  type: response.type
              }
            self.modalView = item;
            console.log(">> DATA:", JSON.stringify(self.modalView));
            self.isModalOpen = true;
            this.$bvModal.show('bv-modal-blvck-transaction');
        })
        .catch((err) => {
              Swal.fire("Error!", `An error occured for fetching Paymongo Source Transaction: ${err}`, "error");
              console.log(err);
        });
      }
    },
    getFloatValue(amount){
      return (amount / 100);
    },
    getStatusTransClassColor(data) {
      return data === 'EXPIRED' ? 'text-danger fw-medium m-0' : data === 'PAID' ? 'text-success fw-medium m-0' : 'text-warning fw-medium m-0'; 
    },
    tableSorting(action){
        var column = "";
        switch(action.sortBy){
            case 'transaction_id' :
                column = 'transaction_id';
                break;
            case 'customer_name' :
                column = 'name';
                break;
            case 'status' :
                column = 'status';
                break;
            case 'blvck_receive' :
                column = 'blvck_receive';
                break;
            case 'package' :
                column = 'package';
                break;
            case 'payment_method' :
                column = 'payment_method';
                break;
            case 'amount' :
                column = 'amount';
                break;
            case 'date' :
                column = 'date';
                break;
        }
        
        this.sortingValue.sort = column;
        this.sortingValue.orderDesc = action.sortDesc;
        this.getBlvckTopupLogs({
          page: this.currentPage,
          rows: this.perPage,
          ...this.sortingValue
        })
    }
  },
};
</script>

<template>
  <div>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-6">
                <div class="mb-3">
                  <h5 class="card-title">
                    <span class="text-muted fw-normal ms-2">{{blvckTopupLogsTotalRows}}</span>
                    Record(s)
                  </h5>
                </div>
              </div>
              <!-- end col -->
              <div class="col-md-6" style="text-align: right;">
                <button class="btn btn-secondary" @click="refresh()">
                  <feather type="refresh-ccw" size="16" class="icon nav-icon"></feather>&nbsp;&nbsp; Refresh
                </button>
              </div>
              <!-- Search and button -->
              <div class="row mt-3 mb-2 px-3">
                <div class="col-md-4 ta-right">
                  <b-form-group description="Search Keyword">
                    <form class="d-flex" @submit.prevent="onSearch()">
                      <b-form-group id="input-group-3" label-for="input-3">
                        <b-form-select
                          class="form-select rounded-0 rounded-start shadow-none"
                          style="width: fit-content"
                          id="input-3"
                          v-model="searchValue.searchField"
                          :options="searchList"
                        ></b-form-select>
                      </b-form-group>

                      <b-input-group>
                        <b-form-input
                          class="rounded-0"
                          v-model="searchValue.search"
                        ></b-form-input>
                      </b-input-group>
                    </form>
                  </b-form-group>
                </div>
                <div class="col-md-8">
                  <div
                    class="
                      d-flex
                      flex-wrap
                      align-items-start
                      justify-content-md-end
                      mt-2 mt-md-0
                      gap-2
                      mb-3 ta-right
                    "
                  >
                    <b-form-group label-for="status" description="Filter by status">
                      <b-form-select class="form-select rounded-0 rounded-start shadow-none" style="width:fit-content"
                        v-model="searchValue.status"
                        :options="statusList"
                      ></b-form-select>
                    </b-form-group>
                    <b-form-group label-for="payment_method" description="Filter by payment method">
                      <b-form-select class="form-select rounded-0 rounded-start shadow-none" style="width:fit-content"
                        v-model="searchValue.payment_method"
                        :options="paymentMethodList"
                      ></b-form-select>
                    </b-form-group>
                    <b-form-group description="Filter by date added">
                      <flat-pickr
                        v-model="searchValue.dateRange"
                        :config="rangeOptions"
                        placeholder="Select a date range"
                        class="form-control"
                        style="width: fit-content"
                      ></flat-pickr>
                    </b-form-group>
                    <a class="btn btn-primary h-fit" @click="onPageUpdate('reset')">
                      <i class='bx bx-search bx-fw'></i>Search
                    </a>
                    <a
                      href="javascript:void(0);"
                      class="btn btn-primary"
                      @click="onExport"
                    >
                      <i class="uil uil-export me-1"></i>
                      Export
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <!-- end col -->

            <div class="table-responsive">
              <div class="table align-middle table-nowrap">
                <b-table
                  :items="blvckTopupLogs"
                  :fields="fields"
                  responsive="sm"
                  :current-page="currentPage"
                  class="table-check"
                  @sort-changed="tableSorting"
                >
                  <template #cell(transaction_id)="data">
                      <!-- @click="
                        infoModalFunction(data.item);
                        fetchTranstionDetails(data.item.transactionId);

                        $bvModal.show('bv-modal-view');
                      " -->
                    <b-link @click="viewModalTransaction(data.item)"
                      class="fw-medium"
                      >{{ data.item.transactionId }}
                    </b-link>
                  </template>

                  <template #cell(customer_name)="data">
                    <span class="text-body fw-medium m-0">{{
                      data.item.customerInfo.name
                    }}</span>
                  </template>

                   <template #cell(status)="data">
                    <p class="text-body m-0">
                      <span :class="getStatusClassColor(data.item.status.toUpperCase())"> {{  data.item.status.toUpperCase()}}  </span>
                    </p>
                  </template>

                  <template #cell(blvck_receive)="data">
                    <p class="text-body text-end   m-0">
                      {{ data.item.vc_amount | toCurrency }}
                    </p>
                  </template>

                  <template #cell(package)="data">
                    <p class="text-body m-0 text-capitalize">
                      {{ data.item.package }}
                    </p>
                  </template>

                  <template #cell(payment_method)="data">
                    <p class="text-body m-0">
                      {{ data.item.paymentMethod }}
                    </p>
                  </template>

                  <template #cell(amount)="data">
                    <p class="text-body text-end m-0">
                      PHP {{ data.item.amount | toCurrency }}
                    </p>
                  </template>

                  <template #cell(date)="data">
                    <p class="text-body m-0">
                      {{ data.item.date | formatDate }}
                    </p>
                  </template>
                </b-table>
              </div>
            </div>
            <!-- end table responsive -->
            <div class="row g-0 text-center" v-if="blvckTopupLogsTotalRows == 0">
              <span>No data to display.</span>
            </div>
            <div class="row g-0 text-center text-sm-start" v-if="blvckTopupLogsTotalRows != 0 && blvckTopupLogsTotalRows > 10">
              <!-- end col -->
              <div class="col-sm-12">
                <div class="row">
                  <div class="col">
                    <div class="form-group row pull-left">
                      <label for="staticEmail" class="col-sm-6 col-form-label">Display:</label>
                      <div class="col-sm-6">
                        <b-form-group label-for="display-record">
                          <b-form-select class="form-select shadow-none w-fit"
                            id="display-record"
                            v-model="perPage"
                            :options="pageOptions"
                            @change="onDisplayChange()"
                          ></b-form-select>
                        </b-form-group>
                      </div>
                    </div>
                    <div
                      class="
                        dataTables_paginate
                        paging_simple_numbers
                        float-end
                      "
                      v-if="blvckTopupLogsTotalRows > perPage"
                    >
                      <!-- pagination -->
                      <b-pagination
                        class="pagination-rounded"
                        v-model="currentPage"
                        :total-rows="blvckTopupLogsTotalRows"
                        @input="onPageUpdate()"
                        :per-page="perPage"
                      ></b-pagination>
                    </div>
                  </div>
                </div>
              </div>
              <!-- end col -->
            </div>


            <!-- end row -->
          </div>
          <!-- end card body -->
        </div>
        <!-- end card -->
      </div>
      <!-- end col -->

      <!-- show info modal -->
      <b-modal id="bv-modal-blvck-transaction" centered title="Blvck Top-up Information" hide-footer>
        <div class="pb-4" v-if="isModalOpen">
          <div class="row">
            <p class="h3 fw-bold">Merchant Information</p>
            <div class="row">
              <div class="col-6">
                <p class="mx-4 fw-bold">Name:</p>
                <p class="mx-4">{{ modalView.customerInfo.name }}</p>
              </div>
              <div class="col-6">
                <p class="mx-4 fw-bold">Mobile Number:</p>
                <p class="mx-4">
                  {{ modalView.customerInfo.mobile }}
                </p>
              </div>
            </div>
            <div class="row">
              <div class="col-6">
                <p class="mx-4 fw-bold">Business Name:</p>
                <p class="mx-4">
                  {{ modalView.customerInfo.businessName }}
                </p>
              </div>
              <div class="col-6">
                <p class="mx-4 fw-bold">Contact Email:</p>
                <p class="mx-4">{{ modalView.customerInfo.email }}</p>
              </div>
            </div>
          </div>
          <p class="h3 fw-bold">Transaction Details</p>
          <div class="row">
            <div class="col-6">
              <p class="mx-4 text-capitalize" ><b>package:</b> {{ modalView.package }}</p>
              <p class="mx-4">
                <b>Payment Method:</b>
                {{ modalView.paymentMethod }}
              </p>
            
          <p class="mx-4"><b>Amount:</b> PHP {{ modalView.amount | toCurrency }}</p>
          </div>
          <div class="col-6">
          <p class="mx-4"><b>Blvck Receive Value:</b> PHP {{ modalView.vc_amount | toCurrency }}</p>
          <p class="mx-4"><b>Date:</b> {{ modalView.date | formatDate }}</p>
          </div>
          </div>

          <div class="row">
            <div class="row">
              <div class="col-6">
                <p class="mx-4 fw-bold">Transaction ID:</p>
                <p class="mx-4">{{ modalView.transView.id }}</p>
              </div>
              
            </div>
            <div class="row">
              <div class="col-12">
                <p class="mx-4"><b>Error Description:</b> {{  modalView.transView.data.failed_message }}</p>
              </div>
            </div>
            
            <div v-if="modalView.transView.id.includes('pay_')" class="row">
              <div class="col-6">
                <p class="mx-4 fw-bold">Amount:</p>
                <p  class="mx-4">
                  PHP {{ getFloatValue(modalView.transView.data.amount) | toCurrency}}
                </p>
              </div>
              <div class="col-6">
                <p class="mx-4 fw-bold">Fee:</p>
                <p class="mx-4">
                  PHP {{ getFloatValue(modalView.transView.data.fee) | toCurrency}}
                </p>
              </div>

              <div class="col-6">
                <p class="mx-4 fw-bold">Net Fee:</p>
                <p  class="mx-4">
                  PHP {{ getFloatValue(modalView.transView.data.net_amount) | toCurrency}}
                </p>
              </div>

              <div class="col-6">
                <p class="mx-4 fw-bold">Status:</p>
                <p class="mx-4">
                <span :class="getStatusTransClassColor(modalView.transView.data.status.toUpperCase())"> {{  modalView.transView.data.status.toUpperCase() }}</span>
                </p>
              </div>
            </div> 

            <div v-if="modalView.transView.id.includes('src_')" class="row">
              <div class="col-6">
                <p class="mx-4 fw-bold">Amount:</p>
                <p  class="mx-4">
                  PHP {{ getFloatValue(modalView.transView.data.amount) | toCurrency }}
                </p>
              </div>
              <div class="col-6">
                <p class="mx-4 fw-bold">Status:</p>
                <p class="mx-4">
                <span :class="getStatusTransClassColor(modalView.transView.data.status.toUpperCase())"> {{  modalView.transView.data.status.toUpperCase() }}</span>
                </p>
              </div>
            </div> 
            <div v-if="modalView.transView.id.includes('pi_')" class="row">
              <div class="col-6">
                <p class="mx-4 fw-bold">Amount:</p>
                <p  class="mx-4">
                  PHP {{ getFloatValue(modalView.transView.data.amount) | toCurrency }}
                </p>
              </div>
              <div class="col-6">
                <p class="mx-4 fw-bold">Status:</p>
                <p class="mx-4">
                <span :class="getStatusTransClassColor(modalView.transView.data.status.toUpperCase())"> {{  modalView.transView.data.status.toUpperCase() }}</span>
                </p>
              </div>
            </div> 
            
            
          </div>
        </div>
      </b-modal>
    </div>
    <!-- end row -->

  </div>
</template>
<style>
.custom-checkbox-method label {
    margin-left: 5px;
}
</style>